

















































import { Mixins, Component, Prop, Watch } from 'vue-property-decorator'
import store from 'src/assets/store'
import MixinAncesstors from 'src/components/presenter/item/MixinAncesstors'
import PersonAvatar from 'src/components/account/PersonAvatar.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar
  }
})
export default class ItemPathBreadcrumbs extends Mixins(MixinAncesstors) {
  more = false
  me = store.state.person

  @Prop()
  readonly item!: Item
}
